import { render, staticRenderFns } from "./ReservedCars.vue?vue&type=template&id=16065d6c&"
import script from "./ReservedCars.vue?vue&type=script&lang=js&"
export * from "./ReservedCars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports